import type { SupportedLanguage } from './index';

export const DASHBOARD_LANGUAGE_STORAGE_KEY = 'kayn_dashboard_language';

export const resolveStoredDashboardLanguage = (): SupportedLanguage => {
  if (typeof localStorage === 'undefined') return 'ar';
  return localStorage.getItem(DASHBOARD_LANGUAGE_STORAGE_KEY) === 'en' ? 'en' : 'ar';
};
